import React from 'react';

//CORE COMPONENTS
import { styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../../../components-core/packages/components-core/dist/text';



const Line = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
    display: ${props => props.isLast ? 'none' : 'block'};
`;

class AccordionContentRows extends React.Component {

    renderRows() {
        const { price, carName } = this.props;

        return (
            <Container 
                wrap={ContainerWrap.always} 
                stretchContent={true} 
                verticalAlign={ContainerVerticalAlignment.center}
            >
                <Container 
                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween} 
                    verticalAlign={ContainerVerticalAlignment.center}
                    wrap={ContainerWrap.never} 
                >
                    <Text appearance={TextAppearance.copy0150}>{carName}</Text>
                    <Text appearance={TextAppearance.copy0150}>{price}</Text>
                </Container>
                <Container 
                    stretchContent={true} 
                    padding={{ top: ContainerPadding.static200, bottom: ContainerPadding.static200 }} 
                >
                    <Line isLast={false}/>
                </Container>
            </Container>
        )
    }

    renderOptionalAccordionRows() {
        const data = this.props.data ;
        const indexOne = this.props.data[0].description;
        const textTwo = this.props.data.title;

            return data.map((row, index) => 
            <Container 
            wrap={ContainerWrap.always} 
            stretchContent={true} 
            verticalAlign={ContainerVerticalAlignment.center}
        >
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.spaceBetween} 
                verticalAlign={ContainerVerticalAlignment.center}
                wrap={ContainerWrap.never} 
            >
                <Container wrap={ContainerWrap.always} horizontalAlign={ContainerHorizontalAlignment.flexStart}>
                   {this.renderOptionalLength(row.title)}
                </Container>
                <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd} wrap={ContainerWrap.always} horizontalAlign={ContainerHorizontalAlignment.horizontalAlign}>
                    <Text 
                        appearance={TextAppearance.copy0150}
                        textAlign={TextAlignment.right}
                        color={TextColor.secondary}
                    >
                    </Text>
                    <Text 
                        appearance={TextAppearance.copy0200}
                        textAlign={TextAlignment.right}
                        
                    >
                        {this.renderDescription(row.title,row.description,data)} 
                    </Text>
                </Container>
            </Container>
            <Container 
                stretchContent={true} 
                padding={{ top: ContainerPadding.static200, bottom: index !== data.length - 1 && ContainerPadding.static200 }} 
            >
                <Line isLast={index === data.length - 1}/>
            </Container>
        </Container>
        
            )
        
 
    }

    renderDescription(title,description,data) {
        if(title == "Anahtar Teslim Fiyatı" && data[1].title==="Kampanyalı Anahtar Teslim Fiyatı"){
            return(
                <Text
                appearance={TextAppearance.copy0200}
                textAlign={TextAlignment.right}
                strikethrough
            >
                {description}
            </Text>
            )
        }else {
            return( <Text
            appearance={TextAppearance.copy0200}
            textAlign={TextAlignment.right}
        >
            {description}
        </Text>)
           
        }

    }

    renderOptionalLength(title){
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        const value = title.split(' ')
        if(value.length > 5 && isMobile) {
            return(
                <Text appearance={TextAppearance.copy0200} >
                            {value[0]+' '+ value[1]+' '+value[2]}<br/>
                            {value[3]+' '+value[4]+' '+value[5]}<br/>
                            {value[6]+' '+value[7]}
                        </Text>
            )
        }else {
            return(  <Text appearance={TextAppearance.copy0200} >
            {title}
        </Text>)
          
        }
    }

    render() {
        const { accordionType } = this.props;

        return (
            <Container stretchContent={true} wrap={ContainerWrap.always}>
                {accordionType === 'optional' ? this.renderOptionalAccordionRows() : this.renderRows()}
            </Container>
        ) 
    }
}


export default AccordionContentRows;